/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TileRateApartment } from './TileRateApartment';
import type { TileRateCancellation } from './TileRateCancellation';
import type { TileRatePrepayment } from './TileRatePrepayment';
import type { TileRateProvision } from './TileRateProvision';
export type TileRate = {
    apartment?: TileRateApartment | null;
    discount?: number;
    baseRate?: number;
    rate?: number;
    convertedRate?: number;
    convertedBaseRate?: number;
    convertedCurrency?: TileRate.convertedCurrency;
    checkIn?: string | null;
    checkOut?: string | null;
    guests?: number;
    provision?: TileRateProvision;
    cancellationPolicy?: TileRateCancellation;
    prepayment?: TileRatePrepayment;
};
export namespace TileRate {
    export enum convertedCurrency {
        UNKNOWN = 'Unknown',
        HUF = 'HUF',
        EUR = 'EUR',
        GBP = 'GBP',
        RON = 'RON',
        PLN = 'PLN',
        USD = 'USD',
        CZK = 'CZK',
    }
}
